<script setup>
  import SurveyContractSetupField from "@/components/Survey/Setup/Fields/SurveyContractSetupField.vue";
  import SurveyCreditsMaxSetupField from "@/components/Survey/Setup/Fields/SurveyCreditsMaxSetupField.vue";
</script>

<template>
  <div class="space-y-6">
    <SurveyContractSetupField />
    <SurveyCreditsMaxSetupField />
  </div>
</template>
